import { useSelector } from 'react-redux';
import { RootState } from '../shared/state/root-reducer';
import {
  ClientWithAiPes,
  resolveSelectedPatientClientId,
  shouldShowCallPatientButton,
} from './call-patient-visibility';

export function useShouldShowCallPatientButton(): boolean {
  const isLoadingClients = useSelector(
    (state: RootState) =>
      state.implementationContext?.implementationSpecialistClient?.isLoading || false
  );
  const allClientsMap = useSelector(
    (state: RootState) =>
      state.implementationContext?.implementationSpecialistClient?.allClientsMap as
        | Map<number, ClientWithAiPes>
        | undefined
  );
  const selectedPatientClientId = useSelector(resolveSelectedPatientClientId);

  return shouldShowCallPatientButton({
    isLoadingClients,
    selectedPatientClientId,
    allClientsMap,
  });
}
